// extracted by mini-css-extract-plugin
export var bioImage = "summitLanding-module--bioImage--f2b17";
export var overviewText = "summitLanding-module--overviewText--5f9c0";
export var overviewTextWrap = "summitLanding-module--overviewTextWrap--ce53a";
export var primaryItem = "summitLanding-module--primaryItem--449f2";
export var primaryStaff = "summitLanding-module--primaryStaff--673c6";
export var sectionHeading = "summitLanding-module--sectionHeading--bbb75";
export var sectionInset = "summitLanding-module--sectionInset--94e07";
export var sectionItem = "summitLanding-module--sectionItem--63379";
export var slideUp = "summitLanding-module--slideUp--97b4a";
export var slideUpLarge = "summitLanding-module--slideUpLarge--63695";
export var socialWrap = "summitLanding-module--socialWrap--ebe9e";
export var speakersContainer = "summitLanding-module--speakersContainer--22d5e";
export var speakersHeader = "summitLanding-module--speakersHeader--68c62";
export var speakersInnerContainer = "summitLanding-module--speakersInnerContainer--c3471";
export var speakersTitle = "summitLanding-module--speakersTitle--ba2cc";
export var speakersWrap = "summitLanding-module--speakersWrap--6c6d0";
export var sponsorItem = "summitLanding-module--sponsorItem--ff049";
export var sponsorLogo = "summitLanding-module--sponsorLogo--c48f2";
export var sponsorsAdditionalContent = "summitLanding-module--sponsorsAdditionalContent--6e7c5";
export var sponsorsSection = "summitLanding-module--sponsorsSection--a1346";
export var staffName = "summitLanding-module--staffName--ff0ff";
export var staffPosition = "summitLanding-module--staffPosition--1cfd6";